import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import i18n from 'modules/core/lib/i18n'

import { PageSkeleton } from 'modules/pages/components/PageSkeleton'
import CollectionsBootstrap from 'modules/pages/lib/CollectionsBootstrap'
import { PagesContextProvider } from 'modules/pages/lib/context/PagesProvider'
import { useAiChatAgent } from 'modules/pages/lib/hooks/useAiChatAgent'
import { usePagesContext } from 'modules/pages/lib/hooks/usePagesContext'

const PagesRootPage = () => {
  const { canSeePages, loading } = usePagesContext()

  useAiChatAgent({
    agent: 'metaworkflow',
    initialMessage: i18n.t('pages.chat.initial_message'),
    welcomeScreenSuggestions: [],
  })

  if (loading) {
    return <PageSkeleton />
  }

  const authorizeFn = () => {
    return canSeePages
  }

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <PagesContextProvider>
        <PagesRootPage />
      </PagesContextProvider>
    </CollectionsBootstrap>
  )
}

export default RootPage
